<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :list-title="listTitle"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="dialogToolbarTitle"
  >
    <v-list two-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile :key="(index + 2 * 100)">
            <v-list-tile-action>
              <v-tooltip bottom>
                <v-btn @click="openExternalMap(item.area_url)" slot="activator" icon flat color="primary">
                  <v-icon>location_on</v-icon>
                </v-btn>
                <span>{{ locationIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title}}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat color="primary" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>
  
    <div slot="dialog-card-text"
    class="select-area-card">
      <v-layout class="area-autocomplete" column align-center justify-center>
        <div class="input-group input-group--dirty input-group--solo input-group--text-field input-group--single-line primary--text"><div class="input-group__input">

        <vue-google-autocomplete
          ref="area"
          id="area"
          classname="form-control"
          placeholder="Busca una ubicación"
          v-on:placechanged="getAddressData"
          v-on:focus="onFocusAutocomplete('area')"
          country="es"
        ></vue-google-autocomplete>
        </div></div>
      </v-layout>
      <v-scale-transition origin="left center">
        <vuetify-form-creator
          class="area-options"
          v-show="this.address.data"
          :columns="'xs12 sm12 md12 lg12'"
          :items="area.form"
          ref="form"
          @on-change="onChange"
        ></vuetify-form-creator>
      </v-scale-transition>
    </div>
    
    <div slot="dialog-card-actions">
      <v-fab-transition>
        <v-btn
          absolute
          dark
          fab
          bottom
          right
          color="primary"
          class="area-buttom"
          v-show="this.address.data && this.area.form[0].value"
          @click="addArea()"
        >
          <v-icon>check</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>
<pre>
  {{items}}
</pre>
  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'
  import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'

  export default {

    name: 'VuetifyAreaAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm,
      VuetifyFormCreator,
      VueGoogleAutocomplete
    },

    props: {
      areas: {
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 450,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete area',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: '¿Delete area?',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      locationIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      value: {
        default: null
      }
    },

    data: () => ({
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: null,
      phoneType: null,
      phoneNumber: null,
      humanizeDuration: require('humanize-duration'),
      address: {
        dialog: false,
        data: null
      },
      area: {
        current: {
          id: 0,
          index: 0
        },
        dialog: false,
        iframe: {
          dialog: false
        },
        visible: false,
        form: [
          {
            ref: '',
            type: 'radio-group',
            label: 'Selecciona el área a habilitar:',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            class: 'area-radio-group',
            itemText: 'quantity_value',
            itemValue: 'quantity_id',
            avatars: false,
            options: [
              {
                value: 'area_postal_code',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'area_locality',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'area_province',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'area_distance',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'area_duration',
                visible: false,
                label: '',
                hint: ''
              }
            ],
            rules: [],
            required: true,
            autocomplete: true,
            disabled: false,
            chips: true
          },
          {
            ref: 'distance',
            type: 'slider',
            label: 'Distancia',
            columns: 'xs12 sm12 md12 lg12',
            visible: false,
            value: 10,
            min: 1,
            max: 1000
          },
          {
            ref: 'duration',
            type: 'slider',
            label: 'Tiempo',
            columns: 'xs12 sm12 md12 lg12',
            visible: false,
            value: 3600000,
            step: 60000,
            min: 60000,
            max: 86400000
          }
        ],
        distance: 0
      }
    }),

    created () {
      if (this.areas.length > 0) {
        this.normalizeAreas(this.areas)
      }
    },

    watch: {
      areas: {
        handler: function (newVal, oldVal) {
          this.normalizeAreas(newVal)
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          this.$emit('update:value', newVal)
        },
        deep: true
      },
      'area.form.0.value': {
        handler: function (newVal, oldVal) {
          console.log(newVal)
          this.area.form[1].visible = false
          this.area.form[2].visible = false
          if (newVal === 'area_distance') {
            this.area.form[1].visible = true
          } else if (newVal === 'area_duration') {
            this.area.form[2].visible = true
          }
        },
        deep: true
      },
      'area.form.1.value': {
        handler: function (newVal, oldVal) {
          this.address.data.distance = newVal
        },
        deep: true
      },
      'area.form.2.value': {
        handler: function (newVal, oldVal) {
          this.address.data.duration = newVal
        },
        deep: true
      }
    },

    methods: {

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange () {
        this.updateAreaOptions()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openExternalMap (url) {
        window.open(url, '_blank')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onFocusAutocomplete: function (ref) {
        // this.$refs[ref].clear()
        // this.address.data = null
        // this.area.form[0].value = null
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeAreas (items) {
        items.map((obj, index) => {
          if (obj.area_filter_name === 'area_postal_code') {
            obj.title = obj.area_postal_code || ''
            obj.subtitle = 'Todo el código postal'
          } else if (obj.area_filter_name === 'area_locality') {
            obj.title = obj.area_locality || ''
            obj.subtitle = 'Toda la localidad'
          } else if (obj.area_filter_name === 'area_province') {
            obj.title = obj.area_province || ''
            obj.subtitle = 'Toda la provincia'
          } else if (obj.area_filter_name === 'area_distance') {
            obj.title = obj.area_distance + ' Km'
            obj.subtitle = 'Distancia máxima del trayecto'
          } else if (obj.area_filter_name === 'area_duration') {
            let time = this.humanizeDuration(
              obj.area_duration, {
                language: 'es',
                round: true,
                units: ['d', 'h', 'm'],
                delimiter: ' y '
              }
            )
            obj.title = time || ''
            obj.subtitle = 'Duración máxima del trayecto'
          }
          return obj
        })
        this.items = items
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addArea () {
        let area = {
          user_id: 0,
          area_filter_id: 0,
          area_filter_name: this.area.form[0].value,
          area_address: this.address.data.address,
          area_postal_code: this.address.data.postalCode,
          area_locality: this.address.data.locality,
          area_province: this.address.data.province,
          area_country: this.address.data.country,
          area_longitude: this.address.data.longitude,
          area_latitude: this.address.data.latitude,
          area_place_id: this.address.data.placeID,
          area_formatted_address: this.address.data.formattedAddress,
          area_url: this.address.data.url,
          area_distance: this.address.data.distance,
          area_duration: this.address.data.duration
        }
        this.items.push(area)
        this.$emit('on-add-area', area)
        this.$refs.area.clear()
        this.area.form[0].value = null
        this.$refs.aggregator.dialog = false
        this.address.data = null
      },

      /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      getAddressData: function (addressData, placeResultData, id) {
        this.address.data = {
          route: addressData.route || '',
          postalCode: addressData.postal_code || '',
          locality: addressData.locality || '',
          province: addressData.administrative_area_level_2 || '',
          country: addressData.country || '',
          latitude: addressData.latitude || '',
          longitude: addressData.longitude || '',
          formattedAddress: placeResultData.formatted_address || '',
          url: placeResultData.url || '',
          distance: this.area.form[1].value || '',
          duration: this.area.form[2].value || '',
          placeID: placeResultData.place_id || ''
        }
        let number = addressData.street_number || ''
        number = number ? ', ' + number : ''
        this.address.data.route += number
        this.updateAreaOptions()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateAreaOptions () {
        if (!this.address.data) {
          return
        }
        if (this.address.data.postalCode !== '') {
          this.area.form[0].options[0].label = this.address.data.postalCode + ' (código postal)'
          this.area.form[0].options[0].hint = 'Todo el código postal ' + this.address.data.postalCode + '.'
          this.area.form[0].options[0].visible = true
        } else {
          this.area.form[0].options[0].visible = false
        }
        if (this.address.data.locality !== '') {
          this.area.form[0].options[1].label = this.address.data.locality + ' (localidad)'
          this.area.form[0].options[1].hint = 'Toda localidad de ' + this.address.data.locality + '.'
          this.area.form[0].options[1].visible = true
        } else {
          this.area.form[0].options[1].visible = false
        }
        if (this.address.data.province !== '') {
          this.area.form[0].options[2].label = this.address.data.province + ' (provincia)'
          this.area.form[0].options[2].hint = 'Toda la provincia de ' + this.address.data.province + '.'
          this.area.form[0].options[2].visible = true
        } else {
          this.area.form[0].options[2].visible = false
        }
        if (this.address.data.placeID !== '') {
          this.area.form[0].options[3].label = this.address.data.distance + ' Km (distancia)'
          this.area.form[0].options[3].hint = 'Trayectos a una distancia máxima de ' + this.area.form[1].value + ' Km conduciendo desde esta ubicación.'
          this.area.form[0].options[3].visible = true
        } else {
          this.area.form[0].options[3].visible = false
        }
        if (this.address.data.placeID !== '') {
          let time = this.humanizeDuration(
            this.address.data.duration, {
              language: 'es',
              round: true,
              units: ['d', 'h', 'm'],
              delimiter: ' y '
            }
          )
          this.area.form[0].options[4].label = time + ' (duración)'
          this.area.form[0].options[4].hint = 'Trayectos de una duración máxima de ' + time + ' conduciendo desde la ubicación seleccionada.'
          this.area.form[0].options[4].visible = true
        } else {
          this.area.form[0].options[4].visible = false
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deleteArea()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteArea () {
        this.$emit('on-delete-area', this.items[this.currentIndex])
        this.items.splice(this.currentIndex, 1)
      }
    }
  }
</script>

<style lang="sass">

.area-radio-group
  margin-bottom: -49px
  margin-top: 7px !important

.area-actions
  margin: 15px 0 -65px 0

.area-actions-card
  margin: 15px 0 9px 0

.area-options
  margin-top: -47px

.area-buttom
  bottom: 18px !important

.select-area-card
  min-height: 536px

.area-autocomplete
  margin: 0 auto
  padding: 16px 16px 32px 16px

.fade
  &-enter-active, &-leave-active, &-leave-to
    transition: .3s ease-out
    position: absolute
    top: 0
    left: 0

  &-enter, &-leave, &-leave-to
    opacity: 0

.list-item
  display: inline-block
  margin-right: 10px

.list-enter-active, .list-leave-active
  transition: all 1s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)
</style>


// WEBPACK FOOTER //
// src/components/vuetify-area-aggregator.vue